import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams } from 'next/navigation';
import { Configure, InfiniteHits, useHits, useInfiniteHits, usePagination } from 'react-instantsearch-hooks-web';
import { useFormat } from 'helpers/hooks/useFormat';
import ContentSearchItem from 'components/commercetools-ui/atoms/search-algolia/content-search';
import CustomStats from 'components/commercetools-ui/atoms/search-algolia/customstats';
interface Props {
  setNoContentSuggestion?: any;
  searchQuery?: string;
  productResults?:any;
  productQuery?:string;
}
interface NoResultProps {
  fallback: ReactNode;
}

function NoResultsBoundary({ children, fallback }: React.PropsWithChildren<NoResultProps>) {
  const { results } = useHits();

  // The `__isArtificial` flag makes sure not to display the No Results message
  // when no hits have been returned.
  if (results && !results?.__isArtificial && results?.nbHits === 0) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }

  return children;
}

const ContentListAlgolia: React.FC<Props> = ({ setNoContentSuggestion, searchQuery,productResults,productQuery }) => {
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });

  const { results, isLastPage } = useInfiniteHits();
  const { locale } = useParams();


  return (
    <>
      {(searchQuery) && (
        <div id="content-suggestions" className={`${productResults?.nbHits === 0 ?"  2xl:px-80 px-24  lg:px-48 xl:px-60":"lg:ml-[18rem] 2xl:ml-[27rem]"} mb-24  px-24 lg:mb-48 `}>
          <Configure hitsPerPage={12} query={productQuery && productQuery?.length > 0 ? productQuery : searchQuery} 
            facets={['*']} filters={`tags:b2c AND tags:methven AND locale:en-${locale}`} 
            attributesToHighlight={[]} // Disable highlighting
            attributesToSnippet={[]} // Disable snippetting
            attributesToRetrieve={[
              "url",
              "seo.meta_image.url",
              "seo.meta_title"
            ]} 
          />
          <CustomStats setNumberOfHits={setNoContentSuggestion} />
          <>
            <div className="mt-24 text-28 font-medium leading-8 text-[#333] lg:mb-12">
              {formatProductMessage({
                id: 'content.suggestions',
                defaultMessage: 'Content Search Suggestions',
              })}
            </div>
            <NoResultsBoundary fallback={<span>No Suggestions found</span>}>
              <InfiniteHits
                hitComponent={({ hit }) => (
                  <ContentSearchItem
                    hit={hit}
                    // onClick={cleanUp}
                  />
                )}
                showPrevious={false}
                classNames={{
                  root: searchQuery ? 'pt-10 sm:pt-32' : 'pt-10 sm:pt-32 lg:pt-0',
                  list: 'grid sm:grid-cols-2 xl:grid-cols-3 gap-16',
                  loadMore:
                    results && results?.nbHits >= 12 && !isLastPage
                      ? 'mt-48 border-1 rounded-none border border-[#2B2C39] bg-[#2B2C39] shadow-sm text-16 text-white hover:!bg-[#394A54] px-18 py-10 md:px-32 md:py-18 w-full md:w-full lg:w-200 lg:block lg:m-auto lg:mt-48'
                      : '!hidden',
                }}
                translations={{
                  showMoreButtonText: formatProductMessage({ id: 'show.more', defaultMessage: 'Show More' }),
                }}
              />
            </NoResultsBoundary>
          </>
        </div>
      )}
    </>
  );
};
export default ContentListAlgolia;
